<ng-template let-extraClass="extraClass" #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [title]="'Browse Pros'"
      [class]="extraClass"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container
*ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }" />

    <tidy-row>
      <form [formGroup]="form" novalidate action="#">
        <div style="display: flex; justify-content: space-between">
          <tidy-select
            [label]="'Property'"
            [items]="propertyItems"
            [form]="form.controls.address"
            formControlName="address"
            (optionChange)="getThumbtackPros()"
            [icon]="'assets/svg/home.svg'"
            style="flex: 1; padding-right: 5px;"
            class="select-property-input" />
          <tidy-select
            [label]="'Service Type'"
            [items]="serviceTypeItems"
            [form]="form.controls.serviceType"
            [selectedItem]="selectedServiceType"
            formControlName="serviceType"
            [icon]="'assets/svg/briefcase.svg'"
            style="flex: 1; padding-left: 5px;"
            class="select-property-input"
            (optionChange)="getThumbtackPros()" />
        </div>
      </form>
    </tidy-row>

    <div class="thumbtack-attribution">
      <tidy-image src="assets/icon/thumbtack_icon.png" class="thumbtack-icon" />
      <tidy-text [helper]="'Powered by Thumbtack'" />
    </div>

    @if (!wasDataLoaded && !wasError) {
      @for (skeleton of skeletons; track skeleton) {
        <tidy-card>
          <div class="skeleton-header">
            <div>
              <ion-skeleton-text animated="true" style="width: 80px; height: 70px; border-radius: 6px;" />
            </div>
            <div>
              <ion-skeleton-text animated="true" style="width: 80%; height: 20px; border-radius: 6px;" />
              <ion-skeleton-text animated="true" style="width: 80%; height: 20px; border-radius: 6px;" />
            </div>
          </div>
          <div>
            <ion-skeleton-text animated="true" style="width: 120px; height: 18px; border-radius: 6px;" />
          </div>
          <div>
            <ion-skeleton-text animated="true" style="width: 150px; height: 18px; border-radius: 6px;" />
          </div>
          <div style="margin-bottom: 10px;">
            <ion-skeleton-text animated="true" style="width: 180px; height: 18px; border-radius: 6px;" />
          </div>
          <tidy-row>
            <ion-skeleton-text animated="true" style="width: 100%; height: 60px; border-radius: 6px;" />
          </tidy-row>
          <tidy-row>
            <ion-skeleton-text animated="true" style="width: 100%; height: 40px; border-radius: 6px;" />
          </tidy-row>
        </tidy-card>
      }
    }

    @if (wasDataLoaded && pros.length > 0) {
      @for (pro of pros; track pro) {
        <tidy-pro-card [pro]="pro" (selectedPro)="openNextStepsModal($event)" />
      }
    }

    @if (wasError) {
      <tidy-row [align]="'center'">
        <tidy-text [body]="'No results found. Please try another category.'" />
      </tidy-row>
    }

  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
